import {
  faCircleCheck,
  faCircleQuestion,
  faCircleXmark,
  faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CircleAlert } from 'lucide-react';

import Calendar from '@/assets/icons/calendar.svg?react';
import Chip from '@/components/atoms/chip';
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from '@/components/atoms/Tooltip';
import { Fact, Relevance } from '@/types';

const DocViewerFact = ({ fact }: { fact: Fact }) => {
  const RelevanceIndicator = ({ relevance }: { relevance: Relevance }) => {
    const getRelevanceInfo = () => {
      switch (relevance) {
        case Relevance.YES:
          return { text: 'Relevant', color: 'text-green-800', icon: faCircleCheck };
        case Relevance.MAYBE:
          return { text: 'Maybe Relevant', color: 'text-orange-400', icon: faCircleQuestion };
        case Relevance.NO:
          return { text: 'Not Relevant', color: 'text-red-800', icon: faCircleXmark };
        default:
          return { text: 'Not Relevant', color: 'text-red-800', icon: faCircleXmark };
      }
    };

    const { text, color, icon } = getRelevanceInfo();

    return (
      <p className={`flex max-w-32 items-center justify-end gap-2 text-xs ${color}`}>
        <FontAwesomeIcon icon={icon} />
        <span>{text}</span>
      </p>
    );
  };
  return (
    <div className="flex w-full items-center justify-between font-normal">
      <div className={`w-full p-2 px-2 pl-2`}>
        <div className="flex w-full justify-between">
          <div className={`flex items-center gap-2 text-xs font-semibold`}>
            <Calendar className="h-3 w-3" />
            {fact.factDateText ? fact.factDateText : '(Date Unknown)'}

            {fact.dateIsAmbiguous && (
              <>
                <TooltipProvider>
                  <Tooltip delayDuration={0}>
                    <TooltipTrigger asChild>
                      <CircleAlert className="h-3.5 w-3.5 text-yellow-500" />
                    </TooltipTrigger>
                    <TooltipContent side="top" align="start">
                      {fact.dateIsAmbiguousText || 'Date format is ambiguous, please check'}
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              </>
            )}
          </div>
          <div className="flex items-center gap-2">
            {fact.inconsistencies && fact.inconsistencies.length ? (
              <Chip className="bg-red-100">
                <FontAwesomeIcon icon={faExclamationTriangle} className="text-red-500" />
                <span className="text-gray-700">Disputed</span>
              </Chip>
            ) : (
              <></>
            )}
            <RelevanceIndicator relevance={fact.relevance} />
          </div>
        </div>

        <div className="flex justify-between gap-1">
          <div className="w-full pt-1 text-xs text-gray-900">
            {fact.description.length > 70 ? fact.description.slice(0, 70) + '...' : fact.description}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocViewerFact;
